module.exports = __webpack_public_path__ + "static/media/homeStoreMobile.e098ea2e.png";